import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-new-version-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './new-version-dialog.component.html',
  styleUrls: ['./new-version-dialog.component.scss']
})
export class NewVersionDialogComponent {
  /**
   * Handles refresh button click - reloads the page
   */
  onRefreshClick(): void {
    // Clear old version hash key if it exists
    sessionStorage.removeItem('app_version_hash');
    // Don't clear build version or popup flag - let them persist so we don't show again
    // Just reload to get the new version
    window.location.reload();
  }
}
